var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-content"},[_c('div',{staticClass:"product-box"},[_c('meeting-product',{ref:"productList"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }